// Texto dos Termos e Condições (fornecido pela Alexandra). Cada parágrafo é uma string; **assim** põe em negrito
// e [texto](/caminho) cria uma ligação. Um item { list: [...] } é uma lista de pontos.
export const TERMOS = {
  updated: "10 de outubro de 2026",
  sections: [
    {
      title: "Identificação",
      body: [
        "O presente website, disponível em www.babybib.pt, é explorado pela titular da atividade associada à marca Babybib.",
        { list: ["Nome: Alexandra Rodrigues", "NIF: 243626282", "Email: babybib.pt@gmail.com"] },
        "A Babybib dedica-se à criação e confeção artesanal de artigos têxteis, nomeadamente artigos para bebés e crianças, podendo alguns produtos ser personalizados de acordo com as especificações do cliente.",
        "Para qualquer questão relacionada com encomendas, produtos ou condições de compra, o cliente poderá contactar a Babybib através do endereço de email indicado acima.",
      ],
    },
    {
      title: "Aceitação dos Termos e Condições",
      body: [
        "A realização de uma encomenda através do website implica a aceitação dos presentes Termos e Condições.",
        "Antes de concluir a compra, o cliente deverá consultar as condições aplicáveis aos produtos, aos pagamentos, aos envios e às devoluções.",
      ],
    },
    {
      title: "Produtos e características",
      body: [
        "Os produtos Babybib são confecionados artesanalmente, com atenção à escolha dos tecidos, aos acabamentos e aos detalhes de cada peça.",
        "Por se tratarem de artigos feitos à mão, podem existir pequenas diferenças entre produtos, nomeadamente na disposição dos padrões, na tonalidade dos tecidos ou em determinados pormenores de confeção.",
        "As fotografias apresentadas no website têm caráter ilustrativo. As cores podem sofrer ligeiras variações em função da iluminação utilizada e das definições do ecrã ou dispositivo do cliente.",
        "Estas diferenças próprias do processo artesanal não constituem, por si só, falta de conformidade, sem prejuízo dos direitos legais do consumidor.",
        "A Babybib procura disponibilizar informações claras sobre as características e opções de cada produto.",
      ],
    },
    {
      title: "Personalização",
      body: [
        "Alguns artigos podem ser personalizados com nomes ou outras características disponibilizadas no momento da compra.",
        "O cliente deverá verificar cuidadosamente todas as informações fornecidas para personalização antes de concluir a encomenda, nomeadamente a grafia do nome e as opções selecionadas.",
        "A Babybib produz os artigos de acordo com as indicações fornecidas pelo cliente. Não poderá ser responsabilizada por erros de personalização resultantes de informações incorretas introduzidas pelo próprio cliente, sem prejuízo dos direitos que legalmente lhe assistam.",
      ],
    },
    {
      title: "Realização e confirmação da encomenda",
      body: [
        "As encomendas são realizadas através dos meios disponibilizados no website. O cliente deverá fornecer os dados necessários ao processamento e à entrega da encomenda.",
        "Após a conclusão da compra, será enviada uma confirmação através do contacto eletrónico indicado pelo cliente, de acordo com o funcionamento da loja online.",
        "A produção apenas será iniciada após a confirmação do pagamento.",
        "Caso seja necessário esclarecer alguma informação relativa à encomenda, a Babybib poderá contactar o cliente.",
        "Se ocorrer uma impossibilidade objetiva de produção ou for identificado um erro manifesto no preço apresentado, a Babybib contactará o cliente para encontrar uma solução adequada, respeitando os direitos legalmente aplicáveis.",
      ],
    },
    {
      title: "Métodos de pagamento",
      body: [
        "A Babybib disponibiliza os seguintes métodos de pagamento:",
        { list: ["Cartão de crédito ou débito, quando disponibilizado no checkout;", "MB WAY;", "Transferência bancária."] },
        "Os métodos efetivamente disponíveis serão apresentados durante o processo de compra. O pagamento deverá ser efetuado de acordo com as instruções apresentadas no momento da encomenda.",
        "A produção só terá início após a confirmação do pagamento.",
      ],
    },
    {
      title: "Confeção e prazos de produção",
      body: [
        "Os artigos Babybib são produzidos artesanalmente, por encomenda.",
        "O prazo habitual de produção é de **2 a 4 semanas**, podendo variar em função da complexidade do pedido, da quantidade de artigos encomendados, da disponibilidade dos materiais e do volume de encomendas existente. Em períodos de maior procura, o prazo de produção poderá ser superior.",
        "Sempre que possível, qualquer prazo diferente do habitual será comunicado ao cliente antes da conclusão da encomenda.",
        "O prazo de produção é distinto do prazo de transporte. A Babybib procurará cumprir os prazos comunicados, respeitando os prazos de entrega legalmente aplicáveis.",
      ],
    },
    {
      title: "Envios e entregas",
      body: [
        "As encomendas são enviadas através dos serviços de transporte disponibilizados pela Babybib, nomeadamente BATCH, CTT Expresso ou CTT Registado, conforme o destino e as opções disponíveis.",
        "Os custos de envio são calculados durante o checkout, de acordo com o destino, o peso da encomenda e o método de envio disponível.",
        "O cliente é responsável por fornecer uma morada de entrega completa e correta. Caso ocorram dificuldades de entrega devido a dados incorretos ou incompletos fornecidos pelo cliente, a Babybib procurará ajudar a resolver a situação, sem prejuízo das responsabilidades legalmente aplicáveis.",
      ],
    },
    {
      title: "Falta de conformidade, defeitos ou danos",
      body: [
        "Os produtos vendidos pela Babybib beneficiam dos direitos legalmente previstos em matéria de conformidade dos bens.",
        "Caso o cliente identifique um defeito, um dano ou uma divergência relativamente ao produto encomendado, deverá contactar a Babybib através do email babybib.pt@gmail.com. Para facilitar a análise da situação, deverá indicar, sempre que possível, o número da encomenda, uma descrição do problema e fotografias do artigo.",
        "A Babybib analisará a situação e dará seguimento ao pedido de acordo com os direitos e as soluções legalmente aplicáveis.",
        "Os direitos do consumidor não são excluídos pelo facto de o artigo ser artesanal ou personalizado.",
      ],
    },
    {
      title: "Alterações e cancelamentos",
      body: [
        "Caso pretenda alterar uma encomenda, o cliente deverá contactar a Babybib o mais rapidamente possível após a sua realização. A possibilidade de alteração dependerá do estado de preparação da encomenda e da natureza do pedido. Uma alteração poderá não ser possível quando a produção já tiver começado ou quando os materiais tenham sido preparados especificamente para a encomenda.",
        "Os pedidos de cancelamento deverão igualmente ser comunicados por email. A possibilidade de cancelamento será analisada de acordo com o estado da encomenda e a legislação aplicável.",
        "As limitações relativas a artigos personalizados não prejudicam os direitos legais do consumidor.",
      ],
    },
    {
      title: "Cuidados e utilização dos produtos",
      body: [
        "Os produtos deverão ser utilizados e conservados de acordo com as instruções de utilização e lavagem disponibilizadas pela Babybib. A utilização inadequada ou o incumprimento das instruções de conservação poderão provocar danos no artigo.",
        "Esta disposição não limita os direitos do consumidor relativamente a defeitos, falta de conformidade ou questões de segurança do produto.",
      ],
    },
    {
      title: "Propriedade intelectual",
      body: [
        "Os textos, fotografias, imagens, logótipo, identidade visual, desenhos, moldes e restantes conteúdos disponibilizados no website pertencem à Babybib ou são utilizados legitimamente pela mesma. Não é permitida a sua reprodução, cópia, distribuição, adaptação ou utilização comercial sem autorização prévia da respetiva titular, salvo nos casos permitidos por lei.",
        "A aquisição de um produto não confere ao cliente direitos de propriedade intelectual sobre a marca ou os conteúdos da Babybib.",
      ],
    },
    {
      title: "Proteção de dados pessoais e cookies",
      body: [
        "Os dados pessoais fornecidos pelos clientes são tratados de acordo com a legislação aplicável em matéria de proteção de dados pessoais.",
        "Para conhecer as finalidades e os fundamentos do tratamento, os prazos de conservação, os direitos dos titulares e as condições de utilização de cookies, o cliente deverá consultar a [Política de Privacidade e Cookies](/privacidade) disponibilizada no website.",
      ],
    },
    {
      title: "Alterações aos Termos e Condições",
      body: [
        "A Babybib poderá atualizar os presentes Termos e Condições sempre que necessário, nomeadamente em consequência de alterações legais ou do funcionamento da loja online.",
        "A versão aplicável a cada encomenda será a que estiver em vigor no momento da respetiva realização, sem prejuízo das disposições legais imperativas.",
      ],
    },
  ],
};
